import { handleActions } from 'redux-actions';
import { PASO_SIGUIENTE_F1, PASO_ANTERIOR_F1, PASO_ACTUAL_F1, LOGOUT } from '../actions';
import { CONSTANTES } from '../../web/utils/Constantes';

const stateDefault = {
    pasoActual  : 0,
    urlActual   : CONSTANTES.RUTA.reportediario,
    totalPasos  : 6,
}

function actualizarURL(pasoActual, urlActual){
    
    switch (pasoActual) {
        case 'login':
            return CONSTANTES.RUTA.login;      
        case 0:
            return CONSTANTES.RUTA.reportediario;  
        case 1:
            return CONSTANTES.RUTA.buscarPoliza;
        case 2:
            return CONSTANTES.RUTA.declarante;
        /*case 3:
            return CONSTANTES.RUTA.siniestro;*/
        case 3:
            return CONSTANTES.RUTA.afiliacion;
        case 4:
            if(urlActual === CONSTANTES.RUTA.activoAgregar){
                return CONSTANTES.RUTA.activoResumen;
            }else if(urlActual === CONSTANTES.RUTA.activosDeclarados){
                return CONSTANTES.RUTA.activoResumen;
            }else if(urlActual === CONSTANTES.RUTA.tipoDesembolso ){
                return CONSTANTES.RUTA.activoResumen
            }else if(urlActual === CONSTANTES.RUTA.siniestro && !JSON.parse(localStorage.getItem('indActivosDeclarados')) && !activosRegistrados() ){  
                return CONSTANTES.RUTA.activoAgregar;
            }else if(urlActual === CONSTANTES.RUTA.siniestro && !JSON.parse(localStorage.getItem('indActivosDeclarados')) && activosRegistrados() ){  
                return CONSTANTES.RUTA.activoResumen
            }else if(urlActual === CONSTANTES.RUTA.siniestro && JSON.parse(localStorage.getItem('indActivosDeclarados')) ){  
                return CONSTANTES.RUTA.activosDeclarados;
            }else if(urlActual === CONSTANTES.RUTA.activoResumen){
                return CONSTANTES.RUTA.activosDeclarados;
            }
            break;
        case 5:
            return CONSTANTES.RUTA.tipoDesembolso;
        case 6:
            return CONSTANTES.RUTA.cuentaAbono;
        case 7:
            return CONSTANTES.RUTA.gracias;
        default:
            return CONSTANTES.RUTA.login
    }
}
function activosRegistrados() {
    let isOk = false;
    if(localStorage.hasOwnProperty('activos')){
        if(JSON.parse(localStorage.getItem('activos')).length > 0){
            JSON.parse(localStorage.getItem('activos')).map(item => {
                if(item.indSeleccion){
                    isOk = true;
                }
                return item;
            })
        }
    }
   return isOk;
}
export default  handleActions(
    {
        [PASO_ANTERIOR_F1]: (state, action) => {
            let paso = state.urlActual;
            if(state.pasoActual === 4 && state.urlActual === CONSTANTES.RUTA.activoAgregar && JSON.parse(localStorage.getItem('indActivosDeclarados'))){
                paso = action.payload.paso;
            }
            else if(state.pasoActual === 4 && state.urlActual === CONSTANTES.RUTA.activoResumen && JSON.parse(localStorage.getItem('indActivosDeclarados'))){
                paso = action.payload.paso;
            }
            else if(state.pasoActual === 4 && state.urlActual === CONSTANTES.RUTA.activoAgregar && activosRegistrados()){
                paso = action.payload.paso;
            }
            else{
                paso = action.payload.paso - 1;
            }
            const url = actualizarURL(paso, state.urlActual);
            let newState = Object.assign( {}, state, { pasoActual: paso, urlActual: url });
            return newState;
        },
        [PASO_SIGUIENTE_F1] : (state, action) => {
            let paso = state.urlActual; 
            if((state.pasoActual === 4 && state.urlActual === CONSTANTES.RUTA.activoAgregar) || (state.pasoActual === 4 && state.urlActual === CONSTANTES.RUTA.activosDeclarados) ){
                paso = action.payload.paso;
            }else {
                paso = action.payload.paso + 1;
            }
            const url = actualizarURL(paso, state.urlActual);
            
            let newState = Object.assign( {}, state, { pasoActual: paso, urlActual: url });
            return newState;
        },
        [PASO_ACTUAL_F1] : (state, action) => {
            return Object.assign( {}, state, { ...action.payload } );
        },
        [LOGOUT] : (state, action) => { 
            return Object.assign({}, stateDefault);
        },
    },
    stateDefault
  );



